export default {
    path: "/workorder",
    name: "workorder",
    meta: {
        icon: "md-clipboard",
        access: "menu_work_order",
        title: "需求工单",
    },
    component: () => import("@/views/Main.vue"),
    children: [
        {
            path: "work-order",
            name: "work-order",
            meta: {
                icon: "md-clipboard",
                access: "menu_work_order_list",
                title: "工单管理",
            },
            component: () => import("@/views/work/order.vue"),
        },
    ],
};
